import React from 'react';
import { View, ScrollView } from 'react-native';

import { isEqual as _isEqual } from 'lodash';
import PropTypes from 'prop-types';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Swap } from '../../Utils/helpers';
import AddCard from '../AddCard';
import PaymentCard from '../PaymentCard';

import styles from './PaymentCardList.Styles';

const sortByDefaultCard = (cards, defaultCard) => {
  const newCards = [...(cards || [])],
    defaultCardIndex = newCards.findIndex(cardElement => {
      return cardElement.lastFourDigits === defaultCard.lastFourDigits;
    });
  if (defaultCardIndex === -1) {
    return newCards;
  }
  Swap(newCards, 0, defaultCardIndex);
  return newCards;
};

function PaymentCardList({
  cards,
  defaultPayment,
  withAddCard,
  onAddCard,
  style,
  onSelectDefaultCard,
  renderExtraCard,
}) {
  return (
    <View style={[styles.container, style]}>
      <ScrollView
        bounces={false}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        horizontal
        nestedScrollEnabled
        testID={FrameworkTestKeys.TopUpPaymentCardListScrollView}
        contentContainerStyle={{ flex: 1 }}
      >
        {sortByDefaultCard(cards, defaultPayment).map((card, index) => (
          <PaymentCard
            testID={FrameworkTestKeys.TPPaymentCard}
            {...card}
            isSelected={_isEqual(defaultPayment, card)}
            key={card.lastFourDigits}
            onPress={onSelectDefaultCard.bind(this, card)}
            customCardStyle={styles.customCardStyle(index)}
          />
        ))}

        {withAddCard && (
          <AddCard
            text="top_up_quick_action_add_payment_method_item_text"
            onPress={onAddCard}
            containerStyle={styles.addCardContainerStyle}
          />
        )}

        {renderExtraCard}
      </ScrollView>
    </View>
  );
}

PaymentCardList.defaultProps = {
  cards: [],
  defaultPayment: {},
  withAddCard: true,
};

PaymentCardList.propTypes = {
  cards: PropTypes.array,
  withAddCard: PropTypes.bool,
  onAddCard: PropTypes.func,
  style: PropTypes.any,
  onSelectDefaultCard: PropTypes.func,
  defaultPayment: PropTypes.object,
  renderExtraCard: PropTypes.node,
};

export { sortByDefaultCard };
export default PaymentCardList;
